import styled from "styled-components";

export const StyledContactAdmin = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize["xxs"]};
  margin-top: 1rem;
  color: ${({ theme }) => theme.color.grey};
`;
